(async function () {
  const gate = document.getElementById('bb-hire-gate');
  const modal = document.getElementById('bb-hire-modal');
  const viewBtn = document.getElementById('bb-view-hire');
  const closeBtn = document.getElementById('bb-hire-close');
  const acceptBtn = document.getElementById('bb-hire-accept');
  const check = document.getElementById('bb-accept-hire');
  const status = document.getElementById('bb-hire-status');

  const checkoutBtn = document.getElementById('checkout'); // your button
  const expressWrap = document.querySelector('.additional-checkout-buttons');

  if (!gate || !checkoutBtn) return;

  function monthsFromPlanName(name) {
    if (!name) return 0;
    const n = String(name).toLowerCase();
    const m = n.match(/(\d+)\s*month/);
    if (m) return parseInt(m[1], 10);
    if (/\bannual|yearly\b/.test(n)) return 12;
    if (/\bsemi-?annual|bi-?annual\b/.test(n)) return 6;
    if (/\bquarter(ly)?\b/.test(n)) return 3;
    if (/\bmonthly\b/.test(n)) return 1;
    return 0;
  }

  async function cartIsRegulated() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return false;
    const cart = await res.json();

    return (cart.items || []).some(item => {
      const spName = item.selling_plan_allocation?.selling_plan?.name || '';
      return monthsFromPlanName(spName) > 3;
    });
  }

  function lockCheckout() {
    checkoutBtn.disabled = true;
    checkoutBtn.setAttribute('aria-disabled', 'true');
    if (expressWrap) expressWrap.style.display = 'none';
  }

  function unlockCheckout() {
    checkoutBtn.disabled = false;
    checkoutBtn.removeAttribute('aria-disabled');
    if (expressWrap) expressWrap.style.removeProperty('display');
  }

  function openModal() { modal.hidden = false; }
  function closeModal() { modal.hidden = true; }

  function setAcceptedUI(accepted) {
    if (!check || !status) return;
    check.disabled = !accepted ? true : false;
    check.checked = !!accepted;
    status.textContent = accepted ? '1/1 accepted' : '0/1 accepted';
  }

  // Detect regulated cart
  const regulated = await cartIsRegulated();
  if (!regulated) {
    // If not regulated, clear stale acceptance
    localStorage.removeItem('bb_hire_accepted');
    return;
  }

  gate.hidden = false;
  lockCheckout();

  // Restore if already accepted for this session
  const accepted = localStorage.getItem('bb_hire_accepted') === 'true';
  if (accepted) {
    setAcceptedUI(true);
    unlockCheckout();
  }

  viewBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);

  acceptBtn?.addEventListener('click', () => {
    localStorage.setItem('bb_hire_accepted', 'true');
    setAcceptedUI(true);
    unlockCheckout();
    closeModal();
  });

  // If cart changes, acceptance should be re-validated.
  // Simplest: clear on any cart form submit.
  document.querySelector('form#cart')?.addEventListener('submit', () => {
    localStorage.removeItem('bb_hire_accepted');
  });
})();
